"use strict";

var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StatusPage = void 0;
require("core-js/modules/es.array.concat.js");
var _classCallCheck2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createClass.js"));
var _assertThisInitialized2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/assertThisInitialized.js"));
var _inherits2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/inherits.js"));
var _createSuper2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createSuper.js"));
var _defineProperty2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _LoginForm = _interopRequireDefault(require("./components/LoginForm.vue"));
var _SignUpForm = _interopRequireDefault(require("./components/SignUpForm.vue"));
var StatusPage;
exports.StatusPage = StatusPage;
(function (StatusPage) {
  StatusPage["LoginSocial"] = "LoginSocial";
  StatusPage["LoginEmail"] = "LoginEmail";
  StatusPage["SignUp"] = "SignUp";
})(StatusPage || (exports.StatusPage = StatusPage = {}));
var AuthPage = /*#__PURE__*/function (_Vue) {
  (0, _inherits2.default)(AuthPage, _Vue);
  var _super = (0, _createSuper2.default)(AuthPage);
  function AuthPage() {
    var _this;
    (0, _classCallCheck2.default)(this, AuthPage);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "status", StatusPage.LoginEmail);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "StatusPage", StatusPage);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "logo", require("@/assets/images/logo.png"));
    return _this;
  }
  (0, _createClass2.default)(AuthPage, [{
    key: "handleChangeStatus",
    value: function handleChangeStatus(status) {
      this.status = status;
    }
  }]);
  return AuthPage;
}(_vuePropertyDecorator.Vue);
AuthPage = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    LoginForm: _LoginForm.default,
    SignUpForm: _SignUpForm.default
  }
})], AuthPage);
var _default = AuthPage;
exports.default = _default;